// Strings for the route filter panel. Kept local to the module so the
// shared i18n table stays untouched.
export default {
  TITLE: 'Фильтр маршрутов',
  HINT: 'Фильтр по дням и курьерам',
  DAYS: 'Дни',
  DAY: 'День',
  COURIERS: 'Курьеры',
  ALL: 'Все',
  NONE: 'Никого',
  RESET: 'Сбросить фильтр',
  EMPTY: 'Маршруты ещё не рассчитаны',
  SELECTED: 'выбрано',
};
